// Import components
import { PacketsSlider, Slide } from 'components/elements/molecules/PacketsSlider';
import { MainPacket } from './components';

// Import hooks
import { useMainPackets } from 'components/views/offer_configurator/components/common/MainPackets/hooks/useMainPackets';

// Import helpers
import { getCalculatedPrice } from 'components/views/offer_configurator/helpers/packets';

// Import context
import MainPacketProvider from 'components/context/main_packet/MainPacketProvider';

type Props = {
	type: 'review' | 'modal';
	closeModal?: () => void;
};

const MainPackets = (props: Props) => {
	const { main, packets, initialSlide, subscription, onSelect, isAnyPromotion, calculated } = useMainPackets(props);

	if (!packets.length) return null;

	return (
		<PacketsSlider initialSlide={initialSlide}>
			{packets.map((packet) => (
				<Slide key={packet.uuid}>
					<MainPacketProvider
						packet={packet}
						isCurrent={subscription?.main.product_uuid === packet.uuid}
						isSelected={main?.uuid === packet.uuid}
						isSubscriptionModification={!!subscription}
						onSelect={onSelect.bind(null, packet)}
						isPricesLoading={!calculated.length}
						expires_on={subscription?.expires_on}
						isCanceled={Boolean(subscription?.isCanceled)}
						isAnyPromotion={isAnyPromotion}
						calculatedPrice={getCalculatedPrice(packet.uuid, calculated)}
					>
						<MainPacket />
					</MainPacketProvider>
				</Slide>
			))}
		</PacketsSlider>
	);
};

export default MainPackets;
